import React, { useState, useEffect, useCallback } from 'react';
import { campaignsAPI, googleAdsAPI, clicksAPI } from '../utils/api';

const PERIOD_UNITS = [
  { value: 'minutes', label: 'minutes' },
  { value: 'hours', label: 'hours' },
  { value: 'days', label: 'days' },
];

const DEFAULT_THRESHOLD_RULES = [
  { clicks: 3, period_value: 10, period_unit: 'minutes' },
  { clicks: 4, period_value: 7, period_unit: 'days' },
  { clicks: 7, period_value: 30, period_unit: 'days' },
];

// ISO 3166-1 alpha-2 codes — must match what ip-api.com / ipapi.co return
const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan' }, { code: 'AL', name: 'Albania' }, { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' }, { code: 'AO', name: 'Angola' }, { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' }, { code: 'AU', name: 'Australia' }, { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' }, { code: 'BH', name: 'Bahrain' }, { code: 'BD', name: 'Bangladesh' },
  { code: 'BY', name: 'Belarus' }, { code: 'BE', name: 'Belgium' }, { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' }, { code: 'BO', name: 'Bolivia' }, { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' }, { code: 'BR', name: 'Brazil' }, { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' }, { code: 'BF', name: 'Burkina Faso' }, { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambodia' }, { code: 'CM', name: 'Cameroon' }, { code: 'CA', name: 'Canada' },
  { code: 'CF', name: 'Central African Republic' }, { code: 'TD', name: 'Chad' }, { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' }, { code: 'CO', name: 'Colombia' }, { code: 'CG', name: 'Congo' },
  { code: 'CR', name: 'Costa Rica' }, { code: 'HR', name: 'Croatia' }, { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' }, { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' },
  { code: 'DO', name: 'Dominican Republic' }, { code: 'EC', name: 'Ecuador' }, { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' }, { code: 'EE', name: 'Estonia' }, { code: 'ET', name: 'Ethiopia' },
  { code: 'FI', name: 'Finland' }, { code: 'FR', name: 'France' }, { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' }, { code: 'GH', name: 'Ghana' }, { code: 'GR', name: 'Greece' },
  { code: 'GT', name: 'Guatemala' }, { code: 'GN', name: 'Guinea' }, { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' }, { code: 'HK', name: 'Hong Kong' }, { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' }, { code: 'IN', name: 'India' }, { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' }, { code: 'IQ', name: 'Iraq' }, { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' }, { code: 'IT', name: 'Italy' }, { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' }, { code: 'JO', name: 'Jordan' }, { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' }, { code: 'KW', name: 'Kuwait' }, { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Laos' }, { code: 'LV', name: 'Latvia' }, { code: 'LB', name: 'Lebanon' },
  { code: 'LY', name: 'Libya' }, { code: 'LT', name: 'Lithuania' }, { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' }, { code: 'MY', name: 'Malaysia' }, { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' }, { code: 'MX', name: 'Mexico' }, { code: 'MD', name: 'Moldova' },
  { code: 'MN', name: 'Mongolia' }, { code: 'ME', name: 'Montenegro' }, { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' }, { code: 'MM', name: 'Myanmar' }, { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' }, { code: 'NZ', name: 'New Zealand' }, { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' }, { code: 'NG', name: 'Nigeria' }, { code: 'KP', name: 'North Korea' },
  { code: 'MK', name: 'North Macedonia' }, { code: 'NO', name: 'Norway' }, { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' }, { code: 'PS', name: 'Palestine' }, { code: 'PA', name: 'Panama' },
  { code: 'PY', name: 'Paraguay' }, { code: 'PE', name: 'Peru' }, { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' }, { code: 'PT', name: 'Portugal' }, { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' }, { code: 'RU', name: 'Russia' }, { code: 'RW', name: 'Rwanda' },
  { code: 'SA', name: 'Saudi Arabia' }, { code: 'SN', name: 'Senegal' }, { code: 'RS', name: 'Serbia' },
  { code: 'SG', name: 'Singapore' }, { code: 'SK', name: 'Slovakia' }, { code: 'SI', name: 'Slovenia' },
  { code: 'SO', name: 'Somalia' }, { code: 'ZA', name: 'South Africa' }, { code: 'KR', name: 'South Korea' },
  { code: 'ES', name: 'Spain' }, { code: 'LK', name: 'Sri Lanka' }, { code: 'SD', name: 'Sudan' },
  { code: 'SE', name: 'Sweden' }, { code: 'CH', name: 'Switzerland' }, { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' }, { code: 'TJ', name: 'Tajikistan' }, { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' }, { code: 'TN', name: 'Tunisia' }, { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' }, { code: 'UG', name: 'Uganda' }, { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' }, { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' }, { code: 'UY', name: 'Uruguay' }, { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VE', name: 'Venezuela' }, { code: 'VN', name: 'Vietnam' }, { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' }, { code: 'ZW', name: 'Zimbabwe' },
];
const COUNTRY_NAME = Object.fromEntries(COUNTRIES.map(c => [c.code, c.name]));

const DEFAULT_RULES = {
  threshold_rules: DEFAULT_THRESHOLD_RULES,
  advanced_mode: false,
  max_clicks_per_10min: 3,
  max_clicks_per_hour: 5,
  max_clicks_per_day: 10,
  max_clicks_per_7days: 20,
  max_clicks_per_30days: 50,
  detect_device_ids: false,
  block_countries_mode: 'block',
  block_countries_list: [],
  block_js_disabled: true,
  block_vpn: true,
  block_tor: true,
  block_datacenter: true,
  behavior_analysis: true,
  min_seconds_on_site: 5,
  monitoring_only: false,
  auto_block: true,
  block_duration_days: 30,
  exclusion_list_max: 500,
  ip_range_exclusion: false,
  manual_exclude_ips: '',
  whitelist_ips: '',
  whitelist_converted_ips: false,
  aggressive_blocking: false,
  cross_domain_blocking: false,
  protected_campaign_ids: [],
  excluded_campaign_ids: [],
};

const TABS = [
  { id: 'thresholds', label: 'Click Thresholds', icon: '\u26A1' },
  { id: 'country', label: 'Country Blocking', icon: '\uD83C\uDF0D' },
  { id: 'detection', label: 'Detection', icon: '\uD83D\uDD0D' },
  { id: 'iplists', label: 'IP Lists', icon: '\uD83D\uDCCB' },
  { id: 'campaigns', label: 'Campaigns', icon: '\uD83D\uDCE2' },
  { id: 'advanced', label: 'Advanced', icon: '\u2699\uFE0F' },
];

/* ── Toggle ── */
function Toggle({ value, onChange }) {
  return (
    <button onClick={() => onChange(!value)} style={{
      width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
      background: value ? 'var(--accent-green)' : 'var(--border)',
      transition: 'background 0.2s', position: 'relative', flexShrink: 0,
    }}>
      <div style={{
        position: 'absolute', top: 3, left: value ? 22 : 3,
        width: 18, height: 18, borderRadius: '50%', background: '#fff',
        transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      }} />
    </button>
  );
}

/* ── Setting Row ── */
function SettingRow({ label, hint, children, noBorder }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '14px 0', borderBottom: noBorder ? 'none' : '1px solid var(--border)',
    }}>
      <div style={{ flex: 1, marginRight: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-primary)', marginBottom: hint ? 3 : 0 }}>{label}</div>
        {hint && <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.4 }}>{hint}</div>}
      </div>
      {children}
    </div>
  );
}

/* ── Country Picker — stores ISO codes, displays names ── */
function CountryPicker({ selected, onChange }) {
  const [query, setQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const q = query.toLowerCase();
  const filtered = COUNTRIES.filter(c =>
    (c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q)) && !selected.includes(c.code)
  ).slice(0, 8);

  return (
    <div>
      {selected.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
          {selected.map(code => (
            <span key={code} style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: 'rgba(239,68,68,0.1)', color: 'var(--accent-red)',
              padding: '6px 12px', borderRadius: 6, fontSize: 12, fontWeight: 500,
              border: '1px solid rgba(239,68,68,0.2)',
            }}>
              {COUNTRY_NAME[code] || code}
              <span onClick={() => onChange(selected.filter(c => c !== code))}
                style={{ cursor: 'pointer', fontWeight: 700, fontSize: 15, lineHeight: 1, opacity: 0.7, marginLeft: 2 }}>&times;</span>
            </span>
          ))}
        </div>
      )}
      <div style={{ position: 'relative' }}>
        <input
          value={query}
          onChange={e => { setQuery(e.target.value); setShowDropdown(true); }}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
          placeholder="Type to search and add countries..."
          style={{ width: '100%', fontSize: 13, padding: '10px 14px', background: 'var(--bg-primary)', color: 'var(--text-primary)', border: '1px solid var(--border)', borderRadius: 8 }}
        />
        {showDropdown && query.length > 0 && filtered.length > 0 && (
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
            background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 8, marginTop: 4, maxHeight: 240, overflowY: 'auto',
            boxShadow: '0 12px 36px rgba(0,0,0,0.4)',
          }}>
            {filtered.map(c => (
              <div key={c.code} onMouseDown={() => { onChange([...selected, c.code]); setQuery(''); }}
                style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 13, color: 'var(--text-primary)', borderBottom: '1px solid var(--border)', transition: 'background 0.1s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-secondary)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <span style={{ fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 11, color: 'var(--text-muted)', marginRight: 8 }}>{c.code}</span>
                {c.name}
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>
        {selected.length} countr{selected.length !== 1 ? 'ies' : 'y'} selected
      </div>
    </div>
  );
}

/* ── Campaign Picker ── */
function CampaignPicker({ label, hint, campaigns, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id]);
  const selectedCampaigns = campaigns.filter(c => selected.includes(c.id));
  const filtered = campaigns.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{label}</div>
          {hint && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{hint}</div>}
        </div>
        <button
          className="btn btn-ghost"
          style={{ padding: '4px 14px', fontSize: 12, borderRadius: 6 }}
          onClick={() => { setOpen(o => !o); setSearch(''); }}
        >
          {open ? 'Close' : 'Select'}
        </button>
      </div>

      {open && (
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
          {campaigns.length > 5 && (
            <div style={{ padding: '8px 10px', borderBottom: '1px solid var(--border)', background: 'var(--bg-secondary)' }}>
              <input
                type="text"
                placeholder="Search campaigns…"
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{
                  width: '100%', background: 'var(--bg-primary)', border: '1px solid var(--border)',
                  borderRadius: 5, padding: '5px 10px', fontSize: 12, color: 'var(--text-primary)',
                  outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
          )}
          <div style={{ maxHeight: 220, overflowY: 'auto', background: 'var(--bg-secondary)' }}>
            {filtered.length === 0 ? (
              <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: '12px 14px' }}>No campaigns found</div>
            ) : filtered.map(c => {
              const isSelected = selected.includes(c.id);
              return (
                <div
                  key={c.id}
                  onClick={() => toggle(c.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px',
                    cursor: 'pointer', fontSize: 12, borderBottom: '1px solid var(--border)',
                    background: isSelected ? 'rgba(88,166,255,0.08)' : 'transparent',
                    transition: 'background 0.15s',
                  }}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = isSelected ? 'rgba(88,166,255,0.08)' : 'transparent'; }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggle(c.id)}
                    onClick={e => e.stopPropagation()}
                    style={{ margin: 0, flexShrink: 0, accentColor: 'var(--accent-blue)', width: 14, height: 14 }}
                  />
                  <span style={{ color: isSelected ? 'var(--accent-blue)' : 'var(--text-primary)', flex: 1 }}>{c.name}</span>
                  {isSelected && (
                    <span style={{ fontSize: 10, color: 'var(--accent-blue)', fontWeight: 600, letterSpacing: 0.3 }}>SELECTED</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {selectedCampaigns.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
          {selectedCampaigns.map(c => (
            <span key={c.id} style={{
              display: 'inline-flex', alignItems: 'center', gap: 5,
              background: 'rgba(88,166,255,0.12)', border: '1px solid rgba(88,166,255,0.25)',
              color: 'var(--accent-blue)', padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 500,
            }}>
              {c.name}
              <span
                onClick={() => toggle(c.id)}
                style={{ cursor: 'pointer', opacity: 0.7, fontSize: 14, lineHeight: 1, fontWeight: 400 }}
              >&times;</span>
            </span>
          ))}
        </div>
      ) : (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', fontStyle: 'italic' }}>
          {label.includes('Protected') ? 'All campaigns protected by default' : 'No campaigns excluded'}
        </div>
      )}
    </div>
  );
}

/* ════════════════════════════════════════════════
   TAB PANELS
   ════════════════════════════════════════════════ */

/* Tab 1: Click Thresholds */
function ThresholdsTab({ rules, onChange }) {
  const updateThreshold = (i, field, val) => {
    const updated = [...rules.threshold_rules];
    updated[i] = { ...updated[i], [field]: val };
    onChange('threshold_rules', updated);
  };
  const addRule = () => {
    if (rules.threshold_rules.length >= 5) return;
    onChange('threshold_rules', [...rules.threshold_rules, { clicks: 5, period_value: 1, period_unit: 'hours' }]);
  };
  const removeRule = (i) => onChange('threshold_rules', rules.threshold_rules.filter((_, idx) => idx !== i));

  return (
    <>
      {/* Threshold rules header */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Click Fraud Threshold</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 16, lineHeight: 1.5 }}>
          Add up to 5 rules to detect IPs based on thresholds. For example: Detect an IP if they click on an ad 3 times within 10 minutes.{' '}
          <a href="/knowledge-center/adjusting-thresholds" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>

        {/* Advanced Mode */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 16px', background: 'var(--bg-secondary)', borderRadius: 8,
          border: '1px solid var(--border)', marginBottom: 12,
        }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>Advanced Mode</div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
              Create separate threshold rules for individual campaigns. Recommended for high volume accounts (&gt;25,000 clicks/month).
            </div>
          </div>
          <Toggle value={rules.advanced_mode} onChange={v => onChange('advanced_mode', v)} />
        </div>

        {/* Rules */}
        {(rules.threshold_rules || []).map((rule, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px',
            background: 'var(--bg-secondary)', borderRadius: 8, border: '1px solid var(--border)',
            marginBottom: 10, flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>Allow up to</span>
            <input type="number" min={1} max={100} value={rule.clicks}
              onChange={e => updateThreshold(i, 'clicks', Math.max(1, Number(e.target.value)))}
              style={{ width: 56, textAlign: 'center', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 16, fontWeight: 700, padding: '6px 4px', borderRadius: 6, border: '2px solid var(--accent-blue)', background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
            />
            <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>ad clicks within</span>
            <input type="number" min={1} max={999} value={rule.period_value}
              onChange={e => updateThreshold(i, 'period_value', Math.max(1, Number(e.target.value)))}
              style={{ width: 56, textAlign: 'center', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 16, fontWeight: 700, padding: '6px 4px', borderRadius: 6, border: '2px solid var(--accent-blue)', background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
            />
            <select value={rule.period_unit} onChange={e => updateThreshold(i, 'period_unit', e.target.value)}
              style={{ width: 'auto', fontSize: 13, padding: '7px 12px', borderRadius: 6 }}>
              {PERIOD_UNITS.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
            </select>
            {rules.threshold_rules.length > 1 && (
              <button onClick={() => removeRule(i)} title="Remove rule"
                style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', color: 'var(--accent-red)', cursor: 'pointer', fontSize: 14, padding: '4px 10px', borderRadius: 6, fontWeight: 600, marginLeft: 'auto' }}>
                Remove
              </button>
            )}
          </div>
        ))}

        {rules.threshold_rules.length < 5 && (
          <button onClick={addRule} className="btn btn-ghost"
            style={{ fontSize: 12, padding: '8px 16px', marginTop: 4, borderColor: 'var(--accent-blue)', color: 'var(--accent-blue)' }}>
            + Add Rule ({rules.threshold_rules.length}/5)
          </button>
        )}
      </div>

      {/* Device IDs */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Detect IPs Based on Device IDs</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 12, lineHeight: 1.5 }}>
          By enabling this feature, ClickSaver will detect IPs that were used by the same device ID to click your ads repeatedly.
          This feature requires the ClickSaver tracking code to be installed.{' '}
          <a href="/knowledge-center/fraud-detection-signals" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <SettingRow label="Enable Device ID Detection" hint="Track and correlate clicks from the same device across different IPs" noBorder>
          <Toggle value={rules.detect_device_ids} onChange={v => onChange('detect_device_ids', v)} />
        </SettingRow>
      </div>

      {/* Min Seconds on Site */}
      <div className="card">
        <div className="section-title">Minimum Seconds On Site</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          Block any IP that spends less than the specified number of seconds on your site.{' '}
          <a href="/knowledge-center/adjusting-thresholds" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, padding: '7px 12px', background: 'rgba(88,166,255,0.07)', border: '1px solid rgba(88,166,255,0.2)', borderRadius: 6 }}>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Block Reason tag in your reports:</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(248,81,73,0.12)', color: '#f85149', border: '1px solid rgba(248,81,73,0.25)' }}>Bounced Immediately</span>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>(requires Behavior Analysis enabled)</span>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px',
          background: 'var(--bg-secondary)', borderRadius: 8, border: '1px solid var(--border)',
        }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>Block any IP that spends less than</span>
          <input type="number" min={1} max={120} value={rules.min_seconds_on_site || 5}
            onChange={e => onChange('min_seconds_on_site', Math.max(1, Number(e.target.value)))}
            style={{ width: 56, textAlign: 'center', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 16, fontWeight: 700, padding: '6px 4px', borderRadius: 6, border: '2px solid var(--accent-blue)', background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
          />
          <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>seconds on your site</span>
        </div>
      </div>
    </>
  );
}

/* Tab 2: Country Blocking */
function CountryTab({ rules, onChange }) {
  return (
    <div className="card">
      <div className="section-title">Block IPs By Country</div>
      <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 12, lineHeight: 1.5 }}>
        Block or allow clicks coming from IPs from specific countries.{' '}
        <a href="/knowledge-center/country-blocking" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
      </p>

      {/* Mode selector */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 12, borderRadius: 10, overflow: 'hidden', border: '1px solid var(--border)' }}>
        {[
          { mode: 'block', label: 'Block any click from these countries' },
          { mode: 'allow', label: 'Only allow clicks from these countries' },
        ].map(opt => (
          <button key={opt.mode} onClick={() => onChange('block_countries_mode', opt.mode)}
            style={{
              flex: 1, padding: '12px 16px', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              background: rules.block_countries_mode === opt.mode ? 'var(--accent-blue)' : 'var(--bg-secondary)',
              color: rules.block_countries_mode === opt.mode ? '#fff' : 'var(--text-secondary)',
              transition: 'all 0.15s',
            }}>
            {opt.label}
          </button>
        ))}
      </div>

      {/* Description */}
      <div style={{
        fontSize: 12, color: 'var(--accent-orange)', marginBottom: 16,
        padding: '10px 14px', background: 'rgba(210,153,34,0.08)', borderRadius: 8,
        border: '1px solid rgba(210,153,34,0.2)',
      }}>
        {rules.block_countries_mode === 'block'
          ? 'Clicks from the countries listed below will be blocked.'
          : 'Only clicks from the countries listed below will be allowed. All other countries will be blocked.'}
      </div>

      <CountryPicker
        selected={rules.block_countries_list || []}
        onChange={v => onChange('block_countries_list', v)}
      />
    </div>
  );
}

/* Tab 3: Detection */
function DetectionTab({ rules, onChange }) {
  return (
    <>
      {/* JS Disabled */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Block JavaScript Disabled Browsers</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          Enabling this feature allows ClickSaver to block IPs once a browser with disabled JavaScript clicks your ads (usually a bot).{' '}
          <a href="/knowledge-center/fraud-detection-signals" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, padding: '7px 12px', background: 'rgba(88,166,255,0.07)', border: '1px solid rgba(88,166,255,0.2)', borderRadius: 6 }}>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Block Reason tag in your reports:</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(248,81,73,0.12)', color: '#f85149', border: '1px solid rgba(248,81,73,0.25)' }}>Bot-like Behaviour</span>
        </div>
        <SettingRow label="Block browsers with JavaScript disabled" hint="Bots and scrapers typically have JavaScript disabled" noBorder>
          <Toggle value={rules.block_js_disabled} onChange={v => onChange('block_js_disabled', v)} />
        </SettingRow>
      </div>

      {/* VPN */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">VPN Blocking</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          By enabling this feature, ClickSaver will block any IP that uses a VPN (Virtual Private Network) to click your ads.{' '}
          <a href="/knowledge-center/fraud-detection-signals" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, padding: '7px 12px', background: 'rgba(88,166,255,0.07)', border: '1px solid rgba(88,166,255,0.2)', borderRadius: 6 }}>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Block Reason tag in your reports:</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(248,81,73,0.12)', color: '#f85149', border: '1px solid rgba(248,81,73,0.25)' }}>VPN Software</span>
        </div>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 12, fontSize: 11, color: 'var(--accent-green)', fontWeight: 600 }}>
          <span>&#10003;</span> Recommended: Enabled
        </div>
        <SettingRow label="Block VPN connections" hint="Detect and block VPN/proxy connections">
          <Toggle value={rules.block_vpn} onChange={v => onChange('block_vpn', v)} />
        </SettingRow>
        <SettingRow label="Block Tor exit nodes" hint="Detect and block Tor network users">
          <Toggle value={rules.block_tor} onChange={v => onChange('block_tor', v)} />
        </SettingRow>
        <SettingRow label="Block datacenter IPs" hint="Detect and block IPs from hosting providers" noBorder>
          <Toggle value={rules.block_datacenter} onChange={v => onChange('block_datacenter', v)} />
        </SettingRow>
      </div>

      {/* Behavior Analysis */}
      <div className="card">
        <div className="section-title">Behavior Analysis</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          By enabling this feature, ClickSaver will record user activity on your site which you can use to determine whether the click was made by a human or a bot. The Tracking Code must be installed on your site for this feature to work.{' '}
          <a href="/knowledge-center/fraud-detection-signals" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 8, padding: '7px 12px', background: 'rgba(88,166,255,0.07)', border: '1px solid rgba(88,166,255,0.2)', borderRadius: 6 }}>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Block Reason tags in your reports:</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(248,81,73,0.12)', color: '#f85149', border: '1px solid rgba(248,81,73,0.25)' }}>Bounced Immediately</span>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>and</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(248,81,73,0.12)', color: '#f85149', border: '1px solid rgba(248,81,73,0.25)' }}>Bot-like Behaviour</span>
        </div>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 12, fontSize: 11, color: 'var(--accent-green)', fontWeight: 600 }}>
          <span>&#10003;</span> Recommended: Enabled
        </div>
        <SettingRow label="Enable Behavior Analysis" hint="Records mouse movements, scroll patterns, and interaction timing" noBorder>
          <Toggle value={rules.behavior_analysis} onChange={v => onChange('behavior_analysis', v)} />
        </SettingRow>
      </div>
    </>
  );
}

/* Tab 4: IP Lists */
function IPListsTab({ rules, onChange }) {
  return (
    <>
      {/* Auto Blocking Settings */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Auto IP Blocking</div>
        <SettingRow label="Auto-block fraudulent IPs" hint="When disabled, clicks are flagged but IPs are not blocked">
          <Toggle value={rules.auto_block} onChange={v => onChange('auto_block', v)} />
        </SettingRow>
        <SettingRow label="Block duration" hint="Number of days each IP will be blocked (1-90)">
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="number" min={1} max={90} value={rules.block_duration_days || 30}
              onChange={e => onChange('block_duration_days', Number(e.target.value))}
              style={{ width: 70, textAlign: 'center', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 14, background: 'var(--bg-primary)', color: 'var(--text-primary)', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 4px' }} />
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>days</span>
          </div>
        </SettingRow>
        <SettingRow label="Exclusion list max" hint="Max IPs in exclusion list (50-500). Longer list = slower refresh.">
          <input type="number" min={50} max={500} value={rules.exclusion_list_max || 500}
            onChange={e => onChange('exclusion_list_max', Number(e.target.value))}
            style={{ width: 70, textAlign: 'center', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 14, background: 'var(--bg-primary)', color: 'var(--text-primary)', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 4px' }} />
        </SettingRow>
        <SettingRow label="IP Range Exclusion" hint="Block ranges (e.g. 172.165.11.*) when too many clicks from same range" noBorder>
          <Toggle value={rules.ip_range_exclusion} onChange={v => onChange('ip_range_exclusion', v)} />
        </SettingRow>
      </div>

      {/* Manual Exclude */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Manually Exclude IPs</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          Enter IP addresses to permanently block. They will be blocked until you remove them.
        </p>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10, padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 6 }}>
          Formats: 112.4.5.67 &nbsp;|&nbsp; 112.4.5.* &nbsp;|&nbsp; 112.4.0.0/16 &nbsp;|&nbsp; 112.4.2.4/23
        </div>
        <textarea rows={6} value={rules.manual_exclude_ips || ''}
          onChange={e => onChange('manual_exclude_ips', e.target.value)}
          placeholder="Enter IP addresses, one per line..."
          style={{ width: '100%', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 12, resize: 'vertical', padding: 12, borderRadius: 8, background: 'var(--bg-secondary)', border: '1px solid var(--border)', color: 'var(--text-primary)' }} />
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
          {(rules.manual_exclude_ips || '').split('\n').filter(l => l.trim()).length} IP(s) entered
        </div>
      </div>

      {/* Whitelist */}
      <div className="card">
        <div className="section-title">Whitelist IPs</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
          Enter IP addresses that ClickSaver should never block. Useful for your own IPs, office, or known partners.
        </p>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10, padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 6 }}>
          Formats: 112.4.5.67 &nbsp;|&nbsp; 112.4.5.* &nbsp;|&nbsp; 112.4.0.0/16
        </div>
        <textarea rows={4} value={rules.whitelist_ips || ''}
          onChange={e => onChange('whitelist_ips', e.target.value)}
          placeholder="Enter IP addresses to whitelist, one per line..."
          style={{ width: '100%', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 12, resize: 'vertical', padding: 12, borderRadius: 8, background: 'var(--bg-secondary)', border: '1px solid var(--border)', color: 'var(--text-primary)' }} />
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
          {(rules.whitelist_ips || '').split('\n').filter(l => l.trim()).length} IP(s) whitelisted
        </div>
        <SettingRow label="Auto-whitelist Converted IPs" hint="Converted IPs will be whitelisted automatically and never blocked" noBorder>
          <Toggle value={rules.whitelist_converted_ips} onChange={v => onChange('whitelist_converted_ips', v)} />
        </SettingRow>
      </div>
    </>
  );
}

/* Tab 5: Campaigns */
function CampaignsTab({ rules, onChange, gadsCampaigns }) {
  return (
    <div className="card">
      <div className="section-title">Campaign Protection</div>
      <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 12, lineHeight: 1.5 }}>
        Choose which Google Ads campaigns are protected by ClickSaver.
      </p>
      <CampaignPicker label="Protected Campaigns" hint="Campaigns ClickSaver is protecting. Leave empty to protect all."
        campaigns={gadsCampaigns} selected={rules.protected_campaign_ids || []} onChange={v => onChange('protected_campaign_ids', v)} />
      <div style={{ borderTop: '1px solid var(--border)', margin: '8px 0 16px' }} />
      <CampaignPicker label="Excluded Campaigns" hint="IPs in these campaigns will not be blocked."
        campaigns={gadsCampaigns} selected={rules.excluded_campaign_ids || []} onChange={v => onChange('excluded_campaign_ids', v)} />
    </div>
  );
}

/* Tab 6: Advanced */
function AdvancedTab({ rules, onChange }) {
  return (
    <>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-title">Advanced Settings</div>
        <SettingRow label="Aggressive Blocking" hint="Extremely aggressive approach to block click fraud. May increase false positives.">
          <Toggle value={rules.aggressive_blocking} onChange={v => onChange('aggressive_blocking', v)} />
        </SettingRow>
        <SettingRow label="Cross Domain Blocking" hint="Block detected IPs across all campaigns of all your domains" noBorder>
          <Toggle value={rules.cross_domain_blocking} onChange={v => onChange('cross_domain_blocking', v)} />
        </SettingRow>
      </div>

      {/* Monitoring Only */}
      <div className="card">
        <div className="section-title">Monitoring Only Mode</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 16, lineHeight: 1.5 }}>
          When enabled, ClickSaver records and scores all clicks but does not block any IPs or push exclusions to Google Ads. Use this to safely evaluate detection before enabling full blocking.{' '}
          <a href="/knowledge-center/monitoring-only-mode" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-blue)', fontSize: 12 }}>Learn More</a>
        </p>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 18px', borderRadius: 10,
          background: rules.monitoring_only ? 'rgba(210,153,34,0.08)' : 'rgba(63,185,80,0.06)',
          border: `1px solid ${rules.monitoring_only ? 'rgba(210,153,34,0.3)' : 'rgba(63,185,80,0.2)'}`,
        }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: rules.monitoring_only ? 'var(--accent-orange)' : 'var(--accent-green)' }}>
              {rules.monitoring_only ? 'Monitoring Only — No blocking active' : 'Full Protection Active'}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3 }}>
              {rules.monitoring_only
                ? 'Clicks are tracked but fraudulent IPs will NOT be blocked'
                : 'Fraudulent IPs are being detected and blocked automatically'}
            </div>
          </div>
          <Toggle value={rules.monitoring_only} onChange={v => onChange('monitoring_only', v)} />
        </div>
      </div>
    </>
  );
}

/* ── Test Rules Panel ── */
const SIGNAL_LABELS_TEST = {
  vpn_detected: 'VPN Software', tor_detected: 'Tor Network', proxy_detected: 'Proxy Detected',
  datacenter_ip: 'Datacenter IP', suspicious_user_agent: 'Suspicious User Agent',
  crawler_detected: 'Bot / Crawler', suspicious_ip_range: 'Suspicious IP Range',
  ip_range_abuse: 'IP Range Abuse', no_referrer: 'No Referrer', previously_blocked: 'Previously Blocked',
  short_time_on_site: 'Bounced Immediately', bot_like_behavior: 'Bot-like Behaviour',
  device_id_multiple_ips: 'Device — Multiple IPs', device_id_excessive_clicks: 'Device — Excessive Clicks',
  cross_domain_blocked: 'Blocked on Another Campaign', country_blocked: 'Country Blocked',
  country_not_allowed: 'Country Not Allowed', manually_excluded: 'Manually Excluded',
  excessive_clicks_10min: 'Over threshold (10 min)', excessive_hourly_clicks: 'Over threshold (1 hr)',
  excessive_daily_clicks: 'Over threshold (24 hrs)', excessive_weekly_clicks: 'Over threshold (7 days)',
  excessive_monthly_clicks: 'Over threshold (30 days)', excessive_clicks_rule1: 'Over threshold (rule 1)',
  excessive_clicks_rule2: 'Over threshold (rule 2)', excessive_clicks_rule3: 'Over threshold (rule 3)',
  whitelisted: 'Whitelisted', manual_block: 'Manually Blocked',
};

function ScoreBar({ score }) {
  const color = score >= 70 ? '#f85149' : score >= 40 ? '#e3b341' : '#3fb950';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ flex: 1, height: 6, background: 'var(--bg-primary)', borderRadius: 3, overflow: 'hidden', minWidth: 60 }}>
        <div style={{ width: `${score}%`, height: '100%', background: color, borderRadius: 3, transition: 'width 0.4s' }} />
      </div>
      <span style={{ fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 13, fontWeight: 700, color, minWidth: 28 }}>{score}</span>
    </div>
  );
}

function TestRulesPanel({ campaignId }) {
  const [ip, setIp] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [runReport, setRunReport] = useState(null);
  const [runLoading, setRunLoading] = useState(false);
  const [runError, setRunError] = useState('');

  const handleTest = async () => {
    if (!ip.trim()) return;
    setLoading(true); setError(''); setResult(null);
    try {
      const r = await clicksAPI.testRules(campaignId, ip.trim());
      setResult(r);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Test failed');
    } finally { setLoading(false); }
  };

  const handleRunAll = async () => {
    setRunLoading(true); setRunError(''); setRunReport(null);
    try {
      const r = await clicksAPI.runTests(campaignId);
      setRunReport(r);
    } catch (e) {
      setRunError(e?.response?.data?.detail || 'Test run failed');
    } finally { setRunLoading(false); }
  };

  const scoreColor = result
    ? result.fraud_score >= 70 ? '#f85149' : result.fraud_score >= 40 ? '#e3b341' : '#3fb950'
    : 'var(--text-muted)';

  return (
    <div style={{ maxWidth: 800, marginTop: 16, marginBottom: 40 }}>
      {/* Manual IP test */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="section-title" style={{ marginBottom: 4 }}>Test Rules</div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 14 }}>
          Enter any IP address to see how your current saved rules would score it. Nothing is recorded or blocked.
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={ip}
            onChange={e => setIp(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleTest()}
            placeholder="e.g. 1.2.3.4"
            style={{ flex: 1, fontSize: 13, fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', padding: '9px 12px' }}
          />
          <button className="btn btn-primary" onClick={handleTest} disabled={loading || !ip.trim() || !campaignId}
            style={{ padding: '9px 20px', fontSize: 13 }}>
            {loading ? 'Testing…' : 'Test'}
          </button>
        </div>

        {error && (
          <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(248,81,73,0.1)', border: '1px solid rgba(248,81,73,0.3)', borderRadius: 8, fontSize: 12, color: '#f85149' }}>
            {error}
          </div>
        )}

        {result && (
          <div style={{ marginTop: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
              <div style={{ flex: 1, height: 8, background: 'var(--bg-secondary)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${result.fraud_score}%`, height: '100%', background: scoreColor, borderRadius: 4, transition: 'width 0.4s' }} />
              </div>
              <span style={{ fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums', fontSize: 20, fontWeight: 700, color: scoreColor, minWidth: 44 }}>
                {result.fraud_score}
              </span>
              <span style={{
                padding: '4px 12px', borderRadius: 6, fontSize: 12, fontWeight: 700,
                background: result.action === 'BLOCK' ? 'rgba(248,81,73,0.15)' : 'rgba(63,185,80,0.15)',
                color: result.action === 'BLOCK' ? '#f85149' : '#3fb950',
              }}>
                {result.action}
              </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
              {[
                { label: 'Country', value: `${result.country} (${result.country_code})` },
                { label: 'Proxy/VPN', value: result.proxy ? 'Yes' : 'No', danger: result.proxy },
                { label: 'Datacenter', value: result.hosting ? 'Yes' : 'No', danger: result.hosting },
              ].map(({ label, value, danger }) => (
                <div key={label} style={{ padding: '6px 12px', background: 'var(--bg-secondary)', borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: 'var(--text-muted)' }}>{label}: </span>
                  <span style={{ color: danger ? '#e3b341' : 'var(--text-primary)', fontWeight: 500 }}>{value}</span>
                </div>
              ))}
            </div>
            {result.signals.length > 0 ? (
              <div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6, fontWeight: 600, letterSpacing: 0.5 }}>TRIGGERED RULES</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {result.signals.map(s => (
                    <span key={s} style={{
                      padding: '4px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600,
                      background: 'rgba(248,81,73,0.12)', color: '#f85149',
                      border: '1px solid rgba(248,81,73,0.25)',
                    }}>
                      {SIGNAL_LABELS_TEST[s] || s.replace(/_/g, ' ')}
                    </span>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 12, color: 'var(--text-muted)', fontStyle: 'italic' }}>No rules triggered — IP looks clean.</div>
            )}
          </div>
        )}
      </div>

      {/* Automated test suite */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
          <div className="section-title" style={{ marginBottom: 0 }}>Run All Tests</div>
          <button className="btn btn-ghost" onClick={handleRunAll} disabled={runLoading || !campaignId}
            style={{ padding: '7px 18px', fontSize: 12, borderColor: 'var(--accent-blue)', color: 'var(--accent-blue)', flexShrink: 0 }}>
            {runLoading ? 'Running…' : 'Run All Tests'}
          </button>
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: runReport ? 16 : 0 }}>
          Automatically verifies your saved rules against common fraud scenarios.
        </p>

        {runError && (
          <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(248,81,73,0.1)', border: '1px solid rgba(248,81,73,0.3)', borderRadius: 8, fontSize: 12, color: '#f85149' }}>
            {runError}
          </div>
        )}

        {runLoading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '16px 0', color: 'var(--text-muted)', fontSize: 13 }}>
            <div className="spinner" style={{ width: 18, height: 18 }} />
            Running test scenarios...
          </div>
        )}

        {runReport && !runLoading && (
          <>
            {/* Summary bar */}
            <div style={{
              display: 'flex', alignItems: 'center', gap: 16, padding: '12px 16px',
              borderRadius: 8, marginBottom: 16,
              background: runReport.failed === 0 ? 'rgba(63,185,80,0.08)' : 'rgba(248,81,73,0.08)',
              border: `1px solid ${runReport.failed === 0 ? 'rgba(63,185,80,0.25)' : 'rgba(248,81,73,0.25)'}`,
            }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: runReport.failed === 0 ? '#3fb950' : '#f85149', fontFamily: 'var(--font-body)', fontVariantNumeric: 'tabular-nums' }}>
                {runReport.passed}/{runReport.total}
              </span>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: runReport.failed === 0 ? '#3fb950' : '#f85149' }}>
                  {runReport.failed === 0 ? 'All tests passed' : `${runReport.failed} test${runReport.failed > 1 ? 's' : ''} failed`}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>
                  {runReport.passed} passed · {runReport.failed} failed · {runReport.total} total
                </div>
              </div>
            </div>

            {/* Test rows */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {runReport.tests.map((t, i) => (
                <div key={i} style={{
                  padding: '12px 14px', borderRadius: 8,
                  background: t.passed ? 'rgba(63,185,80,0.05)' : 'rgba(248,81,73,0.07)',
                  border: `1px solid ${t.passed ? 'rgba(63,185,80,0.18)' : 'rgba(248,81,73,0.25)'}`,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                    <span style={{
                      fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, letterSpacing: 0.5,
                      background: t.passed ? 'rgba(63,185,80,0.15)' : 'rgba(248,81,73,0.15)',
                      color: t.passed ? '#3fb950' : '#f85149',
                      flexShrink: 0,
                    }}>
                      {t.passed ? 'PASS' : 'FAIL'}
                    </span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', flex: 1 }}>{t.name}</span>
                    <span style={{
                      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 4,
                      background: t.action === 'BLOCK' ? 'rgba(248,81,73,0.12)' : 'rgba(63,185,80,0.12)',
                      color: t.action === 'BLOCK' ? '#f85149' : '#3fb950',
                    }}>
                      {t.action}
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: t.signals.length > 0 ? 6 : 0 }}>
                    {t.description}
                    {!t.passed && (
                      <span style={{ color: '#e3b341', marginLeft: 8 }}>
                        (expected {t.expected})
                      </span>
                    )}
                  </div>
                  {t.signals.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                      <ScoreBar score={t.fraud_score} />
                      {t.signals.map(s => (
                        <span key={s} style={{
                          padding: '2px 8px', borderRadius: 10, fontSize: 10, fontWeight: 600,
                          background: 'rgba(88,166,255,0.1)', color: 'var(--accent-blue)',
                          border: '1px solid rgba(88,166,255,0.2)',
                        }}>
                          {SIGNAL_LABELS_TEST[s] || s.replace(/_/g, ' ')}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════
   MAIN COMPONENT
   ════════════════════════════════════════════════ */
// Plan feature gates
// Starter: thresholds + VPN/Tor/datacenter blocking only
// Pro: + behavior analysis, device IDs, country blocking, JS disabled, min seconds
// Advanced: + advanced mode, IP lists, cross-domain, aggressive, campaigns tab
const PLAN_TABS = {
  starter:  ['thresholds', 'detection'],
  pro:      ['thresholds', 'country', 'detection'],
  advanced: ['thresholds', 'country', 'detection', 'iplists', 'campaigns', 'advanced'],
  free:     ['thresholds', 'detection'],
};
const TAB_REQUIRED_PLAN = {
  country:   'pro',
  iplists:   'advanced',
  campaigns: 'advanced',
  advanced:  'advanced',
};
const PLAN_LABEL = { starter: 'Starter', pro: 'Pro', advanced: 'Advanced' };

function UpgradeOverlay({ requiredPlan }) {
  return (
    <div style={{
      textAlign: 'center', padding: '48px 24px',
      background: 'var(--bg-card)', borderRadius: 12,
      border: '1px solid var(--border)',
    }}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
      <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 6 }}>
        {PLAN_LABEL[requiredPlan]} plan required
      </div>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 12, maxWidth: 320, margin: '0 auto 20px' }}>
        Upgrade to the {PLAN_LABEL[requiredPlan]} plan to unlock this feature.
      </div>
      <a href="/settings?tab=billing" style={{
        display: 'inline-block', padding: '10px 24px', borderRadius: 8,
        background: 'linear-gradient(135deg,#2563eb,#7c3aed)', color: '#fff',
        fontWeight: 700, fontSize: 13, textDecoration: 'none',
      }}>
        Upgrade Plan →
      </a>
    </div>
  );
}

export default function DetectionRules({ campaignId, user }) {
  const plan = (user?.plan || 'free').toLowerCase();
  const allowedTabs = PLAN_TABS[plan] || PLAN_TABS.free;

  const [campaigns, setCampaigns] = useState([]);
  const [selectedId, setSelectedId] = useState(campaignId || '');
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gadsCampaigns, setGadsCampaigns] = useState([]);
  const [activeTab, setActiveTab] = useState('thresholds');

  useEffect(() => { campaignsAPI.list().then(setCampaigns).catch(() => {}); }, []);

  useEffect(() => {
    if (campaignId && !selectedId) setSelectedId(campaignId);
  }, [campaignId, selectedId]);

  useEffect(() => {
    if (!selectedId) { setRules(DEFAULT_RULES); return; }
    setLoading(true);
    campaignsAPI.get(selectedId)
      .then(c => {
        const s = c.detection_rules || {};
        setRules({ ...DEFAULT_RULES, ...s, threshold_rules: s.threshold_rules?.length > 0 ? s.threshold_rules : DEFAULT_THRESHOLD_RULES });
      })
      .catch(() => setRules(DEFAULT_RULES))
      .finally(() => setLoading(false));
    googleAdsAPI.listCampaigns(selectedId).then(setGadsCampaigns).catch(() => setGadsCampaigns([]));
  }, [selectedId]);

  const handleChange = useCallback((key, value) => {
    setRules(r => ({ ...r, [key]: value }));
  }, []);

  const handleSave = async () => {
    if (!selectedId) return alert('Select a campaign first');
    setSaving(true);
    try {
      const out = { ...rules };
      const tr = out.threshold_rules || [];
      if (tr[0]) out.max_clicks_per_10min = tr[0].clicks;
      if (tr[1]) out.max_clicks_per_7days = tr[1].clicks;
      if (tr[2]) out.max_clicks_per_30days = tr[2].clicks;
      await campaignsAPI.update(selectedId, { detection_rules: out });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } finally { setSaving(false); }
  };

  const handleReset = () => setRules(DEFAULT_RULES);
  const selectedName = campaigns.find(c => c.id === selectedId)?.name || '';

  return (
    <div>
      <div className="page-header">
        <h1>Manage Detection Rules</h1>
        <p>Configure click fraud detection and IP blocking settings</p>
      </div>

      {/* Campaign selector */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>Campaign</label>
          <select value={selectedId} onChange={e => setSelectedId(e.target.value)}>
            <option value="">Select a campaign...</option>
            {campaigns.map(c => <option key={c.id} value={c.id}>{c.name} — {c.domain}</option>)}
          </select>
        </div>
      </div>

      {!selectedId ? (
        <div style={{
          textAlign: 'center', padding: '48px 24px', color: 'var(--text-muted)', fontSize: 13,
          background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)',
        }}>
          Select a campaign above to configure its detection rules.
        </div>
      ) : loading ? (
        <div className="loading"><div className="spinner" /> Loading rules...</div>
      ) : (
        <>
          {/* Tab bar */}
          <div style={{
            display: 'flex', gap: 0, marginBottom: 14, borderBottom: '1px solid var(--border)',
            overflowX: 'auto', WebkitOverflowScrolling: 'touch',
          }}>
            {TABS.map(tab => {
              const locked = !allowedTabs.includes(tab.id);
              const active = activeTab === tab.id;
              return (
                <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
                  background: 'none', border: 'none', padding: '7px 14px', fontSize: 13, fontWeight: active ? 600 : 500,
                  cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 6,
                  color: active ? 'var(--text-primary)' : locked ? 'var(--text-muted)' : 'var(--text-secondary)',
                  borderBottom: `2px solid ${active ? 'var(--accent-blue)' : 'transparent'}`,
                  marginBottom: -1, transition: 'all 0.15s',
                }}>
                  <span style={{ fontSize: 13 }}>{tab.icon}</span>
                  {tab.label}
                  {locked && <span style={{ fontSize: 10 }}>🔒</span>}
                </button>
              );
            })}
          </div>

          {/* Tab content */}
          <div style={{ maxWidth: 800 }}>
            {activeTab === 'thresholds' && <ThresholdsTab rules={rules} onChange={handleChange} />}
            {activeTab === 'country' && (allowedTabs.includes('country') ? <CountryTab rules={rules} onChange={handleChange} /> : <UpgradeOverlay requiredPlan={TAB_REQUIRED_PLAN.country} />)}
            {activeTab === 'detection' && <DetectionTab rules={rules} onChange={handleChange} />}
            {activeTab === 'iplists' && (allowedTabs.includes('iplists') ? <IPListsTab rules={rules} onChange={handleChange} /> : <UpgradeOverlay requiredPlan={TAB_REQUIRED_PLAN.iplists} />)}
            {activeTab === 'campaigns' && (allowedTabs.includes('campaigns') ? <CampaignsTab rules={rules} onChange={handleChange} gadsCampaigns={gadsCampaigns} /> : <UpgradeOverlay requiredPlan={TAB_REQUIRED_PLAN.campaigns} />)}
            {activeTab === 'advanced' && (allowedTabs.includes('advanced') ? <AdvancedTab rules={rules} onChange={handleChange} /> : <UpgradeOverlay requiredPlan={TAB_REQUIRED_PLAN.advanced} />)}
          </div>

          {/* IPQS note */}
          <div style={{
            maxWidth: 800, padding: '12px 16px', marginTop: 24,
            background: 'rgba(88,166,255,0.08)', border: '1px solid rgba(88,166,255,0.2)',
            borderRadius: 8, fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.5,
          }}>
            <strong style={{ color: 'var(--accent-blue)' }}>Note:</strong> VPN, Tor, and datacenter detection requires an{' '}
            <strong>IPQS API key</strong> set in your backend (<code>IPQS_API_KEY</code>).
          </div>

          {/* Save / Reset */}
          <div style={{ maxWidth: 800, display: 'flex', gap: 12, marginTop: 20, marginBottom: 8 }}>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving || !selectedId}
              style={{ flex: 1, justifyContent: 'center', padding: '12px 20px', fontSize: 14 }}>
              {saved ? 'Saved!' : saving ? 'Saving...' : `Save Rules${selectedName ? ` for ${selectedName}` : ''}`}
            </button>
            <button className="btn btn-ghost" onClick={handleReset} style={{ flexShrink: 0, padding: '12px 20px' }}>
              Reset to Defaults
            </button>
          </div>

          {/* Test Rules */}
          <TestRulesPanel campaignId={selectedId} />
        </>
      )}
    </div>
  );
}
